// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"6264eb23","500":"8a1f31a0","787":"331c843c","910":"ac665c78","913":"5e2eef47"}[chunkId] + ".chunk.js";
};